import { createSelector } from 'reselect';
//////////////////////////////////////////////////

const selectModalStore = (state) => state.modal;

const makeSelectModal = () => createSelector(
  selectModalStore,
  (modal) => ({ ...modal }),
);

const makeSelectModalStatus = () => createSelector(
  selectModalStore,
  ({ isOpened }) => isOpened,
);

export {
  makeSelectModal,
  selectModalStore,
  makeSelectModalStatus,
};
